<!-- <p>user-preapproved-dialog works!</p> -->
<h2 mat-dialog-title>Pre-Approved Visitor</h2>
<div mat-dialog-content>
  <p>Visitor Name: {{ data.firstName }}</p>
  <p>Visit Date: {{ data.visitDateTime | date }}</p>
  <div *ngIf="data.checkOut != null && data.checkIn != null">
    <h5>Visit Completed</h5>
  </div>
  <div *ngIf="data.checkIn != null && !isMatched && data.checkOut == null">
    <h5>Enter Checkout Security Code</h5>
    <ng-otp-input
      (onInputChange)="onOtpChange($event)"
      [config]="config"
    ></ng-otp-input>
  </div>
  <div
    *ngIf="isClickedVerify && isOtpEntered"
    class="security-key-match"
    [ngStyle]="
  isMatched
  ? {
    color: 'green',
    }
  : {color: 'red',}
"
  >
    {{ isMatched ? "OTP Matched" : "Incorrect OTP" }}
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Close</button>
  <button *ngIf="data.checkIn == null" mat-button [mat-dialog-close]="true">
    Remove
  </button>
  <button
    *ngIf="data.checkIn != null && isMatched"
    mat-button
    [mat-dialog-close]="true"
  >
    Checkout
  </button>
  <button
    *ngIf="data.checkIn != null && !isMatched"
    [disabled]="!isOtpEntered"
    mat-button
    (click)="matchOTP()"
  >
    Verify
  </button>
</div>
<ng-template #FetchingDialog>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
